export const avalancheProblems = Object.freeze([
  "new_snow",
  "wind_slab",
  "persistent_weak_layers",
  "wet_snow",
  "gliding_snow",
  "favourable_situation",
  "cornices",
  "no_distinct_problem"
]);
